// setting default content to fill in placeholder data for fields not filled out
function IndustriesModel({ widgets = [] }) {
  return {
    widgets: widgets
  };
}

export default IndustriesModel;
